import { isNil } from 'lodash';
import { Path } from 'slate';

import { getClosestTable } from '../../table/queries/getClosestTable';

export function canAddTable(editor: any, at?: Path) {
  return isNil(getClosestTable(editor, at));
}
